import { config } from "config/config";

export const LIQUID_NATIVE_TOKEN_LABEL = "HBARX";
export const NATIVE_TOKEN_LABEL = "HBAR";

export const tvlCap = {};

// How do I provide dynamic tooltips
export const tooltips = {};

export const urls = {
  faq: "https://docs.staderlabs.com/stader-hbar-staking/faqs",
  termsOfService:
    "https://staderlabs.notion.site/Stader-Terms-of-Service-af2b3b2aa4c942eea76e4857faa248e4",
};

export const transactionsTypeMap = {};

export const transactionsStatusMap = {};

export const NATIVE_TOKEN_MULTIPLIER = 100000000;

export const emissionRate = 574999.999776 * NATIVE_TOKEN_MULTIPLIER; //Per day
export const unBondingTime = 24 * 60 * 60; //24 * 60 * 60; // 24 hours
export const usdTransactionFee = 0.2; // USD
export const version = 1.0;
export const apiPath = "api/v1/";
export const tokenLabel = LIQUID_NATIVE_TOKEN_LABEL;
export const precision = 4; //0.0001
export const fiatPrecision = 2; // 0.01
export const transactionFees = 1; //1 hbar
export const NATIVE_TOKEN_INPUT_MAXIMUM_DECIMAL_POINTS = precision;
export const NATIVE_TOKEN_INPUT_MAXIMUM_INTEGER_POINTS = 9;

export const bannerText = `Current staking rewards are ~575k HBAR/epoch.`;

export const gtmId = "GTM-KCLNW9N";
export const tvlUpdateInterval = 10 * 1000;
export const ratesAPI =
  "https://api.coingecko.com/api/v3/simple/price?ids=hedera-hashgraph&vs_currencies=usd";
